import advanceTransformer from '@/transformers/purchase/advanceByPurchase'
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Updates an advace
 *
 * @param  advance Purchase's id
 * @param  payload
 * @return {Array} Advance's info
 */

const updateAdvanceByPurchase = (payload, advance) =>
  Vue.$http.put(`/purchase/order/${advance}/advance/files/`, advanceTransformer.update(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default updateAdvanceByPurchase


// WEBPACK FOOTER //
// ./src/services/purchase/advance/updateAdvanceByPurchase.js